import { DEBUG, DEFAULT_PREFS } from "./config";
import { getAppCardNode } from "./appCardDefault";
import { DomHelper } from "./domHelper";
import { getBackendData } from "./xhrbackend";
function renderContent(cardNode, username, bearerToken, injectNode, hostname, idString = 'rudi-laps') {
    getBackendData("", `/laps/${username}/psw/${hostname}`, "GET", "application/json", bearerToken, function (response) {
        const formNode = injectNode.querySelector('.rudi-form-input-group');
        if (formNode)
            formNode.classList.add('disabled');
        const productResponseData = JSON.parse(response.target.response);
        const lapsItem = productResponseData[0];
        const medProDataNode = DomHelper.appendNode(injectNode, 'div', ['rudi-medpro-data']);
        if (response.target.status == 403) {
            DomHelper.appendNode(medProDataNode, 'div', [], [], `Zugriff verweigert`);
        }
        else if (response.target.status == 424) {
            DomHelper.appendNode(medProDataNode, 'div', [], [], `Backend steht nicht bereit`);
        }
        else if (productResponseData.length < 1) {
            DomHelper.appendNode(medProDataNode, 'div', [], [], `Zu diesem Hostname wurde keine Daten gefunden`);
        }
        else {
            DomHelper.appendNode(medProDataNode, 'div', [], [], `Hostname: ${lapsItem.cn}`);
            const pswNode = DomHelper.appendNode(medProDataNode, 'div', ['rudi-voucher'], []);
            DomHelper.appendNode(pswNode, 'span', ['rudi-voucher-code'], [], `${lapsItem["ms-Mcs-AdmPwd"]}`);
            cardNode.classList.add('app-open');
            cardNode.classList.remove('rudi-max-height');
        }
        DomHelper.appendCloseSection(cardNode, (event) => {
            cardNode.classList.remove('app-open');
            cardNode.classList.add('rudi-max-height');
            medProDataNode.remove();
            if (formNode) {
                formNode.classList.remove('disabled');
            }
        });
    });
}
export function appOCR(globalStore, username, bearerToken, parentNode, app, userResponse) {
    if (DEBUG)
        console.log("-->appOCR");
    const additionalClassList = [];
    const idString = 'rudi-laps';
    if (!userResponse.odDeskPreferences)
        userResponse.odDeskPreferences = DEFAULT_PREFS;
    const cardNode = getAppCardNode(parentNode, app, username, userResponse.odDeskPreferences, bearerToken, false, additionalClassList, null, true);
    const injectNode = cardNode.querySelector('.rudi-app-inject');
    if (injectNode) {
        injectNode.classList.remove('rudi-app-inject');
        injectNode.classList.remove('disabled');
        injectNode.classList.add('rudi-app-interaction');
        injectNode.setAttribute("id", idString);
        const documentNode = DomHelper.appendNode(injectNode, 'section', additionalClassList, [], "", "odKiDocument");
        const formUploadNode = DomHelper.appendNode(documentNode, 'form', [], [
            { attr: 'id', value: 'rudi-tt-upload' },
            { attr: 'enctype', value: 'multipart/form-data' },
            { attr: 'method', value: 'POST' }
        ]);
        const uploadBox = DomHelper.appendNode(formUploadNode, 'div', ['upload-box', 'mt-3'], []);
        const dropZone = DomHelper.appendNode(uploadBox, 'div', ['drop-zone', 'mt-2', 'p-3'], [], 'Datei hierher ziehen oder klicken');
        const fileInput = DomHelper.appendNode(uploadBox, 'input', ['form-control'], [
            { attr: 'type', value: 'file' },
            { attr: 'id', value: 'odKiFileInput' }
        ]);
        let selectedFile = null;
        let fileList = [];
        function setSelectedFile(file) {
            selectedFile = file;
            if (file) {
                const fileData = new FormData();
                fileData.append("file", file);
                DomHelper.uploadFileForOCR(username, fileData, bearerToken, (result) => {
                });
            }
            else {
                dropZone.textContent = 'Datei hierher ziehen oder klicken';
            }
        }
        fileInput.addEventListener('change', () => {
            setSelectedFile(fileInput.files && fileInput.files.length > 0 ? fileInput.files[0] : null);
        });
        dropZone.addEventListener('click', () => fileInput.click());
        dropZone.addEventListener('dragover', (event) => {
            event.preventDefault();
            dropZone.classList.add('drag-over');
        });
        dropZone.addEventListener('dragleave', () => {
            dropZone.classList.remove('drag-over');
        });
        dropZone.addEventListener('drop', (event) => {
            var _a, _b;
            event.preventDefault();
            dropZone.classList.remove('drag-over');
            const file = (_b = (_a = event.dataTransfer) === null || _a === void 0 ? void 0 : _a.files) === null || _b === void 0 ? void 0 : _b[0];
            if (file) {
                setSelectedFile(file);
            }
        });
    }
}
